<template>
    <customModal 
        :containersm="true"
        :footerShow="true"
        @closeModal="closeModal()"
    >
        <template #title>
          {{ heading }}
        </template>
        <template #body>
            <div class="table-responsive mt-2 scrollable">
               <table class="table table-bordered table-sm" v-if="data.length > 0">
                    <thead>
                        <tr>
                        <th>Site Code</th>
                        <th>Review Date</th>
                        <th>Flag Type</th>
                        <th>Fields</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                        v-for="(signal, index) in flattenedData"
                        :key="index"
                        >
                        <td>{{ signal.siteCode }}</td>
                        <td>{{ filter(signal.runDate) }}</td>
                        <td>{{ signal.flagType }}</td>
                        <td>{{ signal.fieldNames }}</td>
                        </tr>
                    </tbody>
                    </table>

                <div v-else class="text-center py-3">
                     No data found 
                </div>
            </div>
        </template>
    </customModal>
</template>

<script src="./CriticalSignalPopup.js"></script>

<style scoped>  

</style>